import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import OfficeFormPresenter from "../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";
import NavBar from "../../../../../components/navigation";
import withRouter from "../../../../../withRouter";
import RegionTab from "../../../../../components/common/RegionTab";
import Attendees from "./training-tabs/Attendees";
import CardView from "../../../../../components/common/CardView";
import Enrollees from "./training-tabs/Enrollees";

class ViewTrainingList extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "management_training";
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const { training } = this.state.object;
    console.warn("TRAINNNNINGGGG", training);

    const tabs = [
      {
        title: "Attendees",
        content: training ? (
          <Attendees training={training} />
        ) : (
          <div>Loading...</div>
        ),
      },
      {
        title: "Enrollees",
        content: training ? (
          <Enrollees training={training} />
        ) : (
          <div>Loading...</div>
        ),
      },
    ];
    const tabContents = tabs.map((tab) => tab.content);

    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Learning and Development &gt;{" "}
              <span style={{ color: "#333" }}>Details</span>
            </p>
          </div>
          <div>
            {/* <hr /> */}
            <div className="d-flex align-items-center">
              {/* <h4 className="text-primary">Attendees</h4> */}
              <h5>
                Training: <b>{this.state.object.training}</b>
              </h5>
            </div>
            <hr />
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default withRouter(ViewTrainingList);
